<template>
  <div>
    <a
      style="display: flex"
      href="javascript:;"
      class="name-btn"
      @click="goTo()"
    >
      <span v-if="!this.options.truncate">{{ $t(display) }}</span>
      <ag-truncate
        v-if="this.options.truncate"
        :text="$t(display)"
        :data="row"
        :options="this.options.truncate"
      >
      </ag-truncate>
    </a>
  </div>
</template>

<script>
import AgTruncate from "@/components/ag-truncate/index.vue";

export default {
  name: "rowRouter",
  components: {
    AgTruncate,
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      display: "",
    };
  },
  created() {
    this.display = this.data[this.options.displayField];
  },
  methods: {
    goTo() {
      this.$router.push(this.options.route(this.data));
    },
  },
};
</script>
